import { statusLabel, type DashboardStatus } from '../dashboardTypes';

/** A glyph per status so the state is never conveyed by colour alone (SRS accessibility). Decorative: the text beside it says the same thing. */
const GLYPH: Record<DashboardStatus, string> = {
  Overdue: '!', InsufficientFunds: '$', Failed: '×', NeedsReview: '?', PendingPayment: '•', PaymentProcessing: '↻', Paid: '✓', PaidOutsideEscochex: '✓',
};

export function StatusBadge({ status }: { status: DashboardStatus | string }) {
  const known = status in GLYPH;
  return (
    <span className={`tpd-badge tpd-badge--${known ? status : 'Other'}`} data-status={status}>
      <span className="tpd-badge__glyph" aria-hidden="true">{known ? GLYPH[status as DashboardStatus] : '•'}</span>
      {statusLabel(status)}
    </span>
  );
}
